import { css, Theme, useTheme } from '@emotion/react'
import { FC } from 'react'

export type FieldLabelProps = {
  label?: string
  required?: boolean
  htmlFor?: string
  isShowError?: boolean
}

const FieldLabel: FC<FieldLabelProps> = ({
  label,
  htmlFor,
  required = false,
  isShowError = false,
}) => {
  const theme = useTheme()

  if (!label) return null

  return (
    <label
      css={[labelStyle(theme), isShowError && labelErrorStyle(theme)]}
      htmlFor={htmlFor}
    >
      <span css={labelTextStyle()}>{label}</span>
      {required && <span css={requiredStyle(theme)}>*</span>}
    </label>
  )
}

export default FieldLabel

const labelStyle = (theme: Theme) => css`
  display: flex;
  column-gap: 5px;
  color: ${theme.color.white};
  font-size: 18px;
  font-weight: bold;
  line-height: calc(27 / 18);

  @media (max-width: 767px) {
    column-gap: 2px;
    font-size: 16px;
  }
`

const labelErrorStyle = (theme: Theme) => css`
  color: ${theme.color.red};
`

const labelTextStyle = () => css`
  padding-bottom: 2px;
`

const requiredStyle = (theme: Theme) => css`
  color: ${theme.color.red};
  font-size: 20px;
  line-height: calc(29 / 20);
`
